import React from 'react';
import { useTranslation } from 'react-i18next';

export default function AsyncState({
  loading = false,
  error = null,
  empty = false,
  children,
  onRetry,
  onDiagnostics,
  loadingLabel,
  errorTitle,
  errorDescription,
  emptyTitle,
  emptyDescription,
  skeletonRows = 3,
  className = '',
}) {
  const { t } = useTranslation();
  const classes = ['async-state', className].filter(Boolean).join(' ');

  if (loading) {
    const rowCount = Math.max(1, Number(skeletonRows) || 1);
    return (
      <div className={`${classes} async-state--loading`} role="status" aria-live="polite">
        <span className="async-state__sr-only">{loadingLabel || t('asyncStateLoading')}</span>
        <div className="async-state__skeleton" aria-hidden="true">
          {Array.from({ length: rowCount }, (_, index) => (
            <span className="async-state__skeleton-row" key={index} />
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    const detail = errorDescription || (typeof error === 'string' ? error : error.message);
    return (
      <section className={`${classes} async-state--error`} role="alert">
        <span className="async-state__icon" aria-hidden="true">!</span>
        <div className="async-state__content">
          <h3>{errorTitle || t('asyncStateErrorTitle')}</h3>
          <p>{detail || t('asyncStateErrorDescription')}</p>
          {(onRetry || onDiagnostics) && (
            <div className="async-state__actions">
              {onRetry && <button type="button" className="webhooks-primaryBtn enabled" onClick={onRetry}>{t('asyncStateRetry')}</button>}
              {onDiagnostics && <button type="button" className="webhooks-secondaryBtn enabled" onClick={onDiagnostics}>{t('asyncStateDiagnostics')}</button>}
            </div>
          )}
        </div>
      </section>
    );
  }

  if (empty) {
    return (
      <section className={`${classes} async-state--empty`}>
        <span className="async-state__icon" aria-hidden="true">–</span>
        <div className="async-state__content">
          <h3>{emptyTitle || t('asyncStateEmptyTitle')}</h3>
          <p>{emptyDescription || t('asyncStateEmptyDescription')}</p>
          {onRetry && <div className="async-state__actions"><button type="button" className="webhooks-secondaryBtn enabled" onClick={onRetry}>{t('asyncStateRetry')}</button></div>}
        </div>
      </section>
    );
  }

  return children ?? null;
}
